export default function () {

    const elementExists = $('#SerializedIAmToAreaOfInterestsMap').length;

    if(elementExists) {
        let dataString = $('#SerializedIAmToAreaOfInterestsMap')[0].value;
        let data = JSON.parse(dataString);

        let iAm = $('#ContactForm_IAmProperty');
        let areaOfInterest = $('#ContactForm_AreaOfInterest');
    
        iAm.change(function(){
            areaOfInterest.empty();
            $.map(data[$(this).children(":selected").val()], function(val){
                areaOfInterest.append($("<option></option>").val(val).html(val));
            })
        });

        iAm.trigger("change");
    }
}